// extracted by mini-css-extract-plugin
module.exports = {"verification":"KSPWd2SvKOlpqkrWheav","pending":"_Cs4Yq3JpJHZTBIpxHlo","verified":"Me59Ai7kJlyiWdKaAFqk"};